import React, { useState } from 'react';
import '../styles/Contato.css';
import { apiService } from '../services/api';

function Contatos() {
  const [faqOpen, setFaqOpen] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    assunto: '',
    mensagem: ''
  });

  const toggleFaq = (index) => {
    setFaqOpen(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Formatação específica para cada campo
    let formattedValue = value;
    
    if (name === 'nome') {
      // Capitaliza cada palavra do nome
      formattedValue = value.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
    } else if (name === 'email') {
      // Converte email para minúsculo
      formattedValue = value.toLowerCase();
    }
    
    setFormData(prev => ({
      ...prev,
      [name]: formattedValue
    }));
  };

  const handleTelefoneChange = (e) => {
    let value = e.target.value;
    
    // Remove tudo que não é número
    value = value.replace(/\D/g, '');
    
    // Aplica a máscara (61) 99623-0013
    if (value.length >= 11) {
      value = value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (value.length >= 7) {
      value = value.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
    } else if (value.length >= 3) {
      value = value.replace(/(\d{2})(\d{0,5})/, '($1) $2');
    } else if (value.length >= 1) {
      value = value.replace(/(\d{0,2})/, '($1');
    }
    
    setFormData(prev => ({
      ...prev,
      telefone: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSubmitting(true);
      setSubmitMessage(null);

      const response = await apiService.contact.send(formData);

      setFormData({
        nome: '',
        email: '',
        telefone: '',
        assunto: '',
        mensagem: ''
      });
      setSubmitMessage({
        type: 'success',
        text: response.data?.message || 'Mensagem enviada com sucesso! Entraremos em contato em breve.'
      });
    } catch (error) {
      setSubmitMessage({
        type: 'error',
        text: error.response?.data?.message || 'Erro ao enviar mensagem. Tente novamente mais tarde.'
      });
    } finally {
      setSubmitting(false);
    }
  };

  const faqs = [
    {
      question: 'Preciso pagar algo para fazer algum curso?',
      answer: 'Não, todos os cursos oferecidos pela ABRALIBER são gratuitos. Nossa missão é democratizar o acesso à educação de qualidade.'
    },
    {
      question: 'O certificado é gratuito?',
      answer: 'Não. O acesso ao conteúdo dos cursos é gratuito, e o certificado digital de conclusão é opcional e disponibilizado mediante pagamento.'
    },
    {
      question: 'Em quanto tempo eu termino o curso?',
      answer: 'O tempo de conclusão varia de acordo com sua dedicação e ritmo de estudo. Cada curso tem uma carga horária específica, mas você pode estudar no seu próprio ritmo.'
    },
    {
      question: 'O certificado é reconhecido pelo MEC?',
      answer: 'Cursos livres não dependem de reconhecimento do MEC. O certificado digital serve como comprovação de conclusão de curso livre e pode ser usado conforme as regras da instituição ou seleção que o receber.'
    },
    {
      question: 'Como recebo meu certificado?',
      answer: 'Os certificados são emitidos digitalmente e ficam disponíveis na sua área do aluno. Você pode baixar e imprimir quando quiser.'
    },
    {
      question: 'Como funciona a definição de datas no certificado?',
      answer: 'A data de emissão do certificado será automaticamente definida quando você concluir todos os requisitos do curso.'
    },
    {
      question: 'Posso estudar pelo celular?',
      answer: 'Sim! Nossa plataforma é totalmente responsiva e você pode estudar através de qualquer dispositivo: celular, tablet ou computador.'
    },
    {
      question: 'Tenho suporte durante o curso?',
      answer: 'Sim, oferecemos suporte completo através de múltiplos canais: formulário de contato, e-mail e WhatsApp. Nossa equipe está sempre pronta para ajudar.'
    }
  ];

  return (
    <>
    <div className="contato-page">
      <div className="contato-hero">
          <div className="hero-content">
            <h1>Entre em Contato</h1>
            <p className="hero-subtitle">Estamos aqui para ajudar você em sua jornada educacional</p>
          </div>
        </div>

        <div className="contato-container">
          <div className="contact-info-section">
            <div className="section-header">
              <h2>Informações de Contato</h2>
              <div className="section-divider"></div>
            </div>
            
            <div className="contact-cards">
              <div className="contact-card">
                <div className="contact-icon">📧</div>
                <h3>E-mail</h3>
                <p>contato@abraliber.com.br</p>
              </div>
              
              <div className="contact-card">
                <div className="contact-icon">📱</div>
                <h3>WhatsApp</h3>
                <p>(61) 99623-0013</p>
                <p>Atendimento: 8h às 18h</p>
              </div>
              
              <div className="contact-card">
                <div className="contact-icon">🕒</div>
                <h3>Horário de Atendimento</h3>
                <p>Segunda a Sexta: 8h às 18h</p>
                <p>Sábado: 8h às 12h</p>
              </div>
            </div>
          </div>

          <div className="main-content">
            <div className="faq-section">
              <div className="section-header">
                <h2>Perguntas Frequentes</h2>
                <div className="section-divider"></div>
              </div>
              
              <div className="faq-container">
                {faqs.map((faq, index) => (
                  <div key={index} className="faq-item">
                    <button 
                      className={`faq-question ${faqOpen[index] ? 'active' : ''}`}
                      onClick={() => toggleFaq(index)}
                    >
                      <span>{faq.question}</span>
                      <span className="faq-icon">{faqOpen[index] ? '−' : '+'}</span>
                    </button>
                    {faqOpen[index] && (
                      <div className="faq-answer">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="form-section">
              <div className="section-header">
                <h2>Envie sua Mensagem</h2>
                <div className="section-divider"></div>
              </div>
              
              <div className="contato-form">
                <p>Tem alguma dúvida que não foi respondida acima? Entre em contato conosco através do formulário abaixo e nossa equipe responderá em breve.</p>
                
                <form onSubmit={handleSubmit}>
                  {submitMessage && (
                    <div className={`contact-form-message ${submitMessage.type}`}>
                      {submitMessage.text}
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="nome">
                      Nome Completo
                      <input
                        type="text"
                        id="nome"
                        name="nome"
                        value={formData.nome}
                        onChange={handleInputChange}
                        required
                        placeholder="Seu nome completo"
                      />
                    </label>
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">
                      E-mail
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        placeholder="seu@email.com"
                      />
                    </label>
                  </div>

                  <div className="form-group">
                    <label htmlFor="telefone">
                      Telefone/WhatsApp
                      <input
                        type="tel"
                        id="telefone"
                        name="telefone"
                        value={formData.telefone}
                        onChange={handleTelefoneChange}
                        placeholder="(61) 99623-0013"
                      />
                    </label>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="assunto">
                      Assunto
                      <select
                        id="assunto"
                        name="assunto"
                        value={formData.assunto}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Selecione um assunto</option>
                        <option value="duvida-curso">Dúvida sobre curso</option>
                        <option value="suporte-tecnico">Suporte técnico</option>
                        <option value="certificado">Questão sobre certificado</option>
                        <option value="pagamento">Problemas com pagamento</option>
                        <option value="parceria">Proposta de parceria</option>
                        <option value="outro">Outro assunto</option>
                      </select>
                    </label>
                  </div>

                  <div className="form-group">
                    <label htmlFor="mensagem">
                      Mensagem
                      <textarea
                        id="mensagem"
                        name="mensagem"
                        value={formData.mensagem}
                        onChange={handleInputChange}
                        required
                        rows="6"
                        placeholder="Descreva sua dúvida ou mensagem detalhadamente..."
                      />
                    </label>
                  </div>

                  <button type="submit" className="btn-submit" disabled={submitting}>
                    {submitting ? 'Enviando...' : 'Enviar Mensagem'}
                  </button>
                </form>

                <div className="info-text">
                  <p>📧 Também pode nos enviar um e-mail diretamente para <strong>contato@abraliber.com.br</strong></p>
                  <p>⚡ Tempo de resposta: até 24 horas em dias úteis</p>
                  <p>💡 Lembre-se de manter seu e-mail atualizado para garantir uma comunicação eficiente</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contatos;
